export const cleanQueryParams = (params = {}) => {
  const cleaned = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      const sanitized = value
        .map((item) => (item === undefined || item === null ? "" : String(item).trim()))
        .filter(Boolean);

      if (sanitized.length > 0) {
        cleaned[key] = sanitized;
      }
      return;
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed !== "") {
        cleaned[key] = trimmed;
      }
      return;
    }

    cleaned[key] = value;
  });

  return cleaned;
};

export const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  const cleaned = cleanQueryParams(params);

  Object.entries(cleaned).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, String(item)));
      return;
    }

    searchParams.set(key, String(value));
  });

  return searchParams.toString();
};
